import Router from '../../../core/routers/BaseRouter';

export default Router;